import Vue from 'vue'

export function notifyPadrao(title, text, duration = 3000) {
    this.$notify({
        title: title,
        text: text,
        duration: duration
    })
}

export function notifySucesso(title, text, duration = 5000) {
    Vue.notify({
        title: title,
        text: text,
        type: 'success',
        duration: duration
    })
}

export function notifyAviso(title, text, duration = 8000) {
    Vue.notify({
        title: title,
        text: text,
        type: 'warn',
        duration: duration
    })
}

export function notifyErro(title, text, duration = 15000) {
    Vue.notify({
        title: title,
        text: text,
        type: 'error',
        duration: duration
    })
}
